(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp-event-schedule"] && !Shopify.designMode) return;
  try {
    (() => {
    const refresh = () => {
      document.querySelectorAll('[data-dp-events]').forEach(section => {
        const now = Date.now();
        const limit = Number(section.dataset.limit);
        let count = 0;
        section.querySelectorAll('[data-dp-event-end]').forEach(card => {
          const upcoming = Date.parse(card.dataset.dpEventEnd) > now;
          card.hidden = !upcoming || (limit > 0 && count >= limit);
          if (upcoming) count += 1;
        });
        section.querySelectorAll('[data-dp-event-month]').forEach(month => {
          month.hidden = !Array.from(month.querySelectorAll('[data-dp-event-end]')).some(card => !card.hidden);
        });
        section.querySelector('[data-dp-event-empty]').hidden = count > 0;
        section.querySelector('[data-dp-event-timezone]').hidden = count === 0;
      });
    };
    const scheduleNext = () => {
      refresh();
      const now = Date.now();
      const ends = Array.from(document.querySelectorAll('[data-dp-event-end]')).map(card => Date.parse(card.dataset.dpEventEnd)).filter(end => end > now);
      const delay = ends.length ? Math.min(60000, Math.max(1000, Math.min(...ends) - now + 50)) : 60000;
      window.setTimeout(scheduleNext, delay);
    };
    scheduleNext();
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
